"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var starWarsHtml;
var timeout;
function StarWars() {
    var hint = document.createElement("link");
    hint.rel = "preconnect";
    hint.href = 'https://www.youtube.com/embed/_D0ZQPqeJkk?autoplay=1';
    var starWarsDiv = document.createElement('div');
    starWarsDiv.innerHTML = starWarsHtml;
    if (!timeout) {
        timeout = setTimeout(function () {
            clearTimeout(timeout);
            timeout = null;
            starWarsDiv.remove();
            hint.remove();
        }, 95000);
    }
    else {
        return;
    }
    document.querySelector('body').appendChild(starWarsDiv);
    var scrollTextEl = document.querySelector('.star-wars.active #target > div');
    var scrollTextHeight = scrollTextEl.offsetHeight;
    scrollTextEl.style.bottom = '-' + scrollTextHeight + 'px';
    document.head.appendChild(hint);
    document.onkeydown = function (evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key == "Escape" || evt.key == "Esc");
        }
        else {
            isEscape = (evt.keyCode == 27);
        }
        if (isEscape) {
            clearTimeout(timeout);
            timeout = null;
            starWarsDiv.remove();
            hint.remove();
        }
    };
    bigBang();
}
exports.StarWars = StarWars;
function setHtml(html) {
    starWarsHtml = html;
}
exports.setHtml = setHtml;
function bigBang() {
    var windowWidth = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
    var windowHeight = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
    var canvas = document.querySelector('#canvas');
    canvas.width = windowWidth;
    canvas.height = windowHeight;
    var ctx = canvas.getContext('2d');
    function smallStarCreate(starNumber, starSize) {
        for (var i = 0; i < starNumber; i++) {
            ctx.beginPath();
            var starLeft = Math.floor(Math.random() * windowWidth) + 1;
            var starTop = Math.floor(Math.random() * windowHeight) + 1;
            var colorVal01 = Math.floor(Math.random() * 106) + 150;
            var colorVal02 = Math.floor(Math.random() * 106) + 150;
            var opacityVal = (Math.floor(Math.random() * 11)) / 10;
            ctx.fillStyle = "rgba(" + colorVal01 + ", " + colorVal02 + ", " + 255 + ", " + opacityVal + ")";
            ctx.fillRect(starLeft, starTop, starSize, starSize);
            ctx.fill();
        }
    }
    smallStarCreate(300, 1);
    smallStarCreate(150, 2);
    ctx.restore();
    ctx.save();
    function bigStarCreate(starNumber, starSize) {
        for (var i = 0; i < starNumber; i++) {
            ctx.beginPath();
            var starLeft = Math.floor(Math.random() * windowWidth) + 1;
            var starTop = Math.floor(Math.random() * windowHeight) + 1;
            var colorVal01 = Math.floor(Math.random() * 106) + 150;
            var colorVal02 = Math.floor(Math.random() * 106) + 150;
            var opacityVal = (Math.floor(Math.random() * 11)) / 10;
            var radgrad = ctx.createRadialGradient(starLeft, starTop, 0, starLeft, starTop, starSize);
            radgrad.addColorStop(0, 'rgba(255, 255, 255, 1)');
            radgrad.addColorStop(1, "rgba(" + colorVal01 + ", " + colorVal02 + ", " + 255 + ", " + opacityVal + ")");
            ctx.fillStyle = radgrad;
            ctx.arc(starLeft, starTop, starSize, 0, Math.PI * 2, true);
            ctx.fill();
        }
    }
    bigStarCreate(50, 1);
    bigStarCreate(20, 2);
    var sky = new Image();
    sky.src = canvas.toDataURL("image/png");
    canvas.style.background = "url(" + sky.src + ") center center no-repeat";
    ctx.restore();
    ctx.save();
}
